import React, { Fragment, Component } from "react";
import { Button, Row, Col, Form, InputGroup, Container } from "react-bootstrap";
import TableShopOrdersList from "./TableShopOrdersList";
import LoadingProgressBar from "../../../spinners/LoadingProgressBar";
import "react-widgets/dist/css/react-widgets.css";
import $ from "jquery";
import EventFilter from "../../../forms/dropdowns/EventFilter";
import RowsDropdown from "../../../forms/dropdowns/RowsDropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEraser, faLongArrowAltLeft, faLongArrowAltRight, faSync } from "@fortawesome/free-solid-svg-icons";
import NoPermission from "../../../other/NoPermission";

class ShopOrdersList extends Component {
    state = {
        showNOR: this.props.numberOfRecords,
        displayNOR: this.props.numberOfRecords,
        shopOrdersList: this.props.dataList,
        originalShopOrdersList: this.props.dataList,
        searchedPhrase: "",
        loading: this.props.dataList ? false : true,
        selectedEvent: this.props.activeEvent ? this.props.activeEvent.code : "all",
        showOrderDetailsModal: false,
        showOrderStatusModal: false,
        modalParam: null,
        noPermission: false,
    };

    handleSearch = (e) => {
        const searchedPhrase = e.target.value.toLowerCase();
        const { originalShopOrdersList } = this.state;
        this.setState({ searchedPhrase: searchedPhrase });
        if (searchedPhrase !== "") {
            let filteredShopOrders = originalShopOrdersList;

            filteredShopOrders = filteredShopOrders.filter(
                (el) => el.shord_code.toString().toLowerCase().includes(searchedPhrase) || el.user_fullname.toString().toLowerCase().includes(searchedPhrase)
            );
            this.setState({ shopOrdersList: filteredShopOrders });
        } else {
            this.setState({ shopOrdersList: originalShopOrdersList });
        }
    };

    handleDownloadData = () => {
        this.props.onResizeWindow("tableNotLoaded");
        this.setState({ loading: true });
        this.getShopOrdersList();
    };

    getShopOrdersList = async () => {
        const { fetchURL, onShowAlert, onGetDataList, t } = this.props;
        try {
            const response = await fetch(`${fetchURL}/shop-orders-list`, {
                credentials: "include",
                method: "POST",
            });
            if (response.status === 200) {
                await response.json().then((fetchedData) => {
                    //console.log(fetchedData);
                    if (fetchedData.status === "noPermission") this.setState({ noPermission: true });
                    else if (fetchedData.status === "notLogged") this.props.onShowHomePage();
                    else if (fetchedData.status === false) onShowAlert({ variant: "danger", message: t(`error.${fetchedData.code}`) });
                    else {
                        const shopOrdersList = fetchedData.shopOrdersList;
                        this.setState({ shopOrdersList: shopOrdersList, originalShopOrdersList: shopOrdersList }, () => {
                            this.setState({ loading: false });
                            onGetDataList(shopOrdersList);
                        });
                    }
                });
            }
        } catch (err) {
            onShowAlert({ variant: "danger", message: `${t("error.cannotFetchData")} (${err})` });
            this.setState({ loading: false });
        }
    };

    componentDidMount() {
        this.getShopOrdersList();
        const { onResizeWindow } = this.props;
        onResizeWindow("tableNotLoaded");
        $(window).on("resize", function () {
            onResizeWindow("tableLoaded");
        });
    }

    componentDidUpdate() {
        const { onResizeWindow } = this.props;
        if (!this.state.loading) {
            $("#loadTable").fadeIn(200);
            if ($(".light-border").outerHeight() && $(".rest-info").outerHeight()) {
                onResizeWindow("tableLoaded");
            }
        }
    }

    render() {
        const { shopOrdersList, searchedPhrase, loading, displayNOR, showNOR, selectedEvent, noPermission } = this.state;
        const { onDisplaySubPage, onChangeNavAndPage, t, eventFilterValue, onCheckUserPrivilage } = this.props;

        //wyfiltrowana lista
        let filteredShopOrdersList = null;
        if (shopOrdersList) filteredShopOrdersList = shopOrdersList.filter((e) => eventFilterValue === "all" || e.event_code === eventFilterValue);
        const currentPageParams = { nav: "shop", subpage: "shopOrdersList", params: "" };
        return (
            <Fragment>
                {noPermission ? (
                    <NoPermission t={t} option="oneNavbar" />
                ) : (
                    <Fragment>
                        <Container fluid className="pt-2 second-bar">
                            <Row>
                                <Col lg={3} xs={12}>
                                    <Form.Label>{t("form.searching")}</Form.Label>
                                    <InputGroup className="mb-3">
                                        <Form.Control type="text" placeholder={t("form.search")} onChange={this.handleSearch} value={searchedPhrase} />
                                        {searchedPhrase && (
                                            <InputGroup.Append>
                                                <Button
                                                    variant="outline-primary"
                                                    onClick={() =>
                                                        this.setState({
                                                            searchedPhrase: "",
                                                            shopOrdersList: this.state.originalShopOrdersList,
                                                        })
                                                    }
                                                >
                                                    <FontAwesomeIcon icon={faEraser} />
                                                </Button>
                                            </InputGroup.Append>
                                        )}
                                    </InputGroup>
                                </Col>
                                <Col xl={1} lg={2} md={2} xs={4}>
                                    <RowsDropdown
                                        t={t}
                                        defaultValue={this.props.numberOfRecords}
                                        onChangeValue={(event, { value }) => {
                                            this.setState({
                                                showNOR: value,
                                                displayNOR: value,
                                            });
                                            this.props.onChangeNOR(value);
                                        }}
                                    />
                                </Col>
                                <Col lg={2} md={3} xs={5}>
                                    <EventFilter t={t} eventFilterValue={this.props.eventFilterValue} eventsList={this.props.eventsList} onChangeEventFilter={this.props.onChangeEventFilter} />
                                </Col>
                                <Col lg={{ span: 2, offset: 4 }} xs={12} className="text-left text-lg-right mt-lg-3 mt-lg-0 mb-3">
                                    <Button variant="outline-primary" onClick={this.handleDownloadData} className="btn-sync mr-3">
                                        <FontAwesomeIcon icon={faSync} />
                                    </Button>
                                    {onCheckUserPrivilage("ACCR_SHOP_ORDER_ACTIONS") && (
                                        <Button
                                            variant="outline-primary"
                                            type="button"
                                            onClick={() => {
                                                onChangeNavAndPage({ nav: "shop", subpage: "addShopOrder", params: "" }, currentPageParams);
                                            }}
                                            disabled={loading}
                                        >
                                            {t("shop.addOrder")}
                                        </Button>
                                    )}
                                </Col>
                            </Row>
                        </Container>
                        <Container fluid className="content-body">
                            {loading ? (
                                <LoadingProgressBar t={t} />
                            ) : (
                                <div id="loadTable" style={{ display: "none" }}>
                                    <Row>
                                        <Col>
                                            <div className="table-responsive table-fixed-head">
                                                {filteredShopOrdersList.length > 0 ? (
                                                    <Fragment>
                                                        <TableShopOrdersList
                                                            shopOrdersList={filteredShopOrdersList}
                                                            displayNOR={displayNOR}
                                                            onDisplaySubPage={onDisplaySubPage}
                                                            onChangeNavAndPage={onChangeNavAndPage}
                                                            selectedEvent={selectedEvent}
                                                            t={t}
                                                        />
                                                        <div className="light-border"></div>
                                                    </Fragment>
                                                ) : (
                                                    <div className="text-center">{t("notFound")}</div>
                                                )}
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className="rest-info py-3">
                                        <Col>
                                            {t("loaded")} {displayNOR > filteredShopOrdersList.length ? filteredShopOrdersList.length : displayNOR} {t("from")} {filteredShopOrdersList.length}{" "}
                                            {t("records")}
                                        </Col>
                                        <Col className="text-center">
                                            {displayNOR >= filteredShopOrdersList.length ? (
                                                <p className="opacity-4">
                                                    <FontAwesomeIcon icon={faLongArrowAltRight} />
                                                    <span className="px-3">{t("thatsAll")}</span>
                                                    <FontAwesomeIcon icon={faLongArrowAltLeft} />
                                                </p>
                                            ) : (
                                                <Button onClick={() => this.setState({ displayNOR: showNOR + displayNOR })} variant="outline-primary">
                                                    {t("loadMore")}
                                                </Button>
                                            )}
                                        </Col>
                                        <Col></Col>
                                    </Row>
                                </div>
                            )}
                        </Container>
                    </Fragment>
                )}
            </Fragment>
        );
    }
}

export default ShopOrdersList;
